import React from 'react';

const BadmaYoga = () => {
    return (
        <h1>Бадма Ёга дацан</h1>
        //  <h1>Түвшинширээ</h1>
    )
}
export default BadmaYoga;